import React from "react";
import { Row, Col } from "react-flexbox-grid";
import "./contactSocial.scss";


//import FacebookIcon from "../../../assets/contact/facebook.svg";
//import TwitterIcons from "../../../assets/contact/twitter.svg";
//import DribbleIcon from "../../../assets/contact/dribble.svg";
import { SocialIcon } from 'react-social-icons';


const contactSocial = () => (
  <Row>
    <Col xs={12}>
      <Row center="xs">

        <Col xs={12} lg={1} className="contact__social">
		  <SocialIcon url="https://www.instagram.com/petejenny/" />
        </Col>

        <Col xs={12} lg={1} className="contact__social">
		  <SocialIcon url="https://github.com/pgforward" />
        </Col>
	  
        <Col xs={12} lg={1} className="contact__social">
		  <SocialIcon url="https://twitter.com/ozblend" />
        </Col>

	  
        <Col xs={12} lg={1} className="contact__social">
		<SocialIcon url="https://www.facebook.com/pgforward" />
        </Col>

		
        <Col xs={12} lg={1} className="contact__social">
          <SocialIcon url="https://linktr.ee/Peter181" />
        </Col>
		
		
		
		
      </Row>
    </Col>
  </Row>
);

export default contactSocial;
